import { Overlay, Container, Title, Text, rem } from '@mantine/core';
import React from 'react';
import { Waves } from './Waves';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles((theme, _, u) => ({
  hero: {
    maxHeight: '800px',
    width: '100%',
    top: 0,
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transition: 'max-height 1s ease-in-out',
    paddingBottom: '64px',
  },

  scrolled: {
    maxHeight: '80px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    zIndex: 11,
    position: 'relative',
  },

  title: {
    fontSize: rem(60),
    fontWeight: 700,
    lineHeight: 1.2,

    [u.smallerThan('sm')]: {
      fontSize: rem(36),
      lineHeight: 1.2,
    },

    [u.smallerThan('xs')]: {
      fontSize: rem(28),
      lineHeight: 1.3,
    },
  },

  headerText: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.white,
  },

  description: {
    color: theme.white,
    maxWidth: 600,

    [u.smallerThan('sm')]: {
      maxWidth: '100%',
      fontSize: theme.fontSizes.sm,
    },
  },

  control: {
    marginTop: `calc(${theme.spacing.xl} * 1.5)`,

    [u.smallerThan('sm')]: {
      width: '100%',
    },
  },
  wavesContainer: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    display: 'flex',
  },
}));

interface PageHeroProps {
  waveColors: string[];
  waveHeight: number | string;
  headerText?: string;
  headerTitle?: string;
}

export const PageHero: React.FC<PageHeroProps> = ({
  waveColors,
  waveHeight,
  headerText,
  headerTitle,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.hero}>
      <Overlay
        gradient={
          'radial-gradient(circle, hsla(193, 28%, 29%, 1) 0%, hsla(193, 28%, 29%, 1) 0%, hsla(203, 87%, 15%, 1) 63%, hsla(202, 100%, 5%, 1) 100%)'
        }
        opacity={1}
        zIndex={0}
      />

      <Container
        className={classes.container}
        style={{ paddingTop: headerTitle ? 148 : 72, paddingBottom: headerTitle ? 96 : 48 }}>
        {headerTitle && (
          <Title className={classes.title} c={'white'}>
            {headerTitle}
          </Title>
        )}
        {headerText && <Text className={classes.headerText}>{headerText}</Text>}
      </Container>
      <div className={classes.wavesContainer}>
        <Waves colors={waveColors} order={[1, 2, 3, 4]} height={waveHeight} />
      </div>
    </div>
  );
};
